var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('v-app-bar',{staticClass:"app-bar",attrs:{"app":"","flat":"","color":"white"}},[_c('HomeLogo',{attrs:{"to":"/datasets"}}),_c('v-spacer'),_c('v-divider',{attrs:{"vertical":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }